
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putRestrictionRuleSlice = createApi(`PutRestrictionRuleSlice`,"PUT");

const PutRestrictionRuleSlice = createSlice({
  name: 'PutRestrictionRuleSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putRestrictionRuleSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putRestrictionRuleSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putRestrictionRuleSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutRestrictionRuleSlice.reducer;